module.exports = __webpack_public_path__ + "assets/media/day29.2823c38d.mp3";